"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWebVitals = void 0;
var browser_1 = require("@cian/config/browser");
var browser_2 = require("@cian/telemetry/browser");
var web_vitals_1 = require("web-vitals");
var browser_3 = require("@cian/http-api/browser");
var browser_4 = require("@cian/logger/browser");
function initWebVitals() {
    var config = (0, browser_1.getConfig)();
    var telemetry = (0, browser_2.getTelemetry)();
    var httpApi = (0, browser_3.getHttpApi)();
    var isEnabled = config.get('web.browser.vitals.enabled');
    if (!isEnabled) {
        return;
    }
    var transport = config.getStrict('web.browser.vitals.transport');
    var metricsPathApi = config.getStrict('web.browser.vitals.pathApi');
    var metricsMicroserviceName = config.getStrict('web.browser.vitals.microserviceName');
    var logTelemetry = config.get('web.browser.vitals.log');
    var deviceType = config.getStrict('web.deviceType');
    var microserviceName = config.getStrict('projectName');
    var url = window.location.href;
    function handler(_a) {
        var _b;
        var name = _a.name, value = _a.value;
        if (transport === 'telemetry') {
            telemetry.timer("frontend-metrics.".concat(deviceType, ".").concat(name), value);
            return;
        }
        httpApi
            .fetch({
            microserviceName: metricsMicroserviceName,
            pathApi: metricsPathApi,
            assertStatusCodes: [200, 400],
            method: 'POST',
            parameters: (_b = {
                    microserviceName: microserviceName,
                    deviceType: deviceType,
                    url: url
                },
                _b[name] = value,
                _b),
            responseType: 'json',
        })
            .then(function (res) {
            if (!logTelemetry) {
                return;
            }
            var keyPart = res.statusCode === 200 ? 'success' : 'miss';
            telemetry.increment("frontend-metrics.".concat(deviceType, ".").concat(keyPart));
        })
            .catch(function (err) {
            (0, browser_4.getLogger)().error(err);
        });
    }
    (0, web_vitals_1.getCLS)(handler);
    (0, web_vitals_1.getFID)(handler);
    (0, web_vitals_1.getLCP)(handler);
    (0, web_vitals_1.getFCP)(handler);
    (0, web_vitals_1.getTTFB)(handler);
}
exports.initWebVitals = initWebVitals;
//# sourceMappingURL=vitals.js.map